import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IBankInfo } from '../interfaces/bank';
import { EditService } from './edit.service';
import { Injectable } from '@angular/core';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class BankService extends EditService<null, null> {
  url = '/api/bankaccounts';
  entityTitle = 'BankService';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  save(bankInfo: IBankInfo): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });

    return this.handleRequest(
      this.http.post(this.url + '/save', bankInfo, { headers: headers }),
      this.handlersFactory.getForUpdate(this.entityTitle),
    );
  }

  getCurrentOrgBankAccount(): Promise<any> {
    return this.http
      .get<any>(`${this.url}/getCurrentOrgBankAccount`)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getOrgBankAccount(orgId: number): Promise<any> {
    return this.http
      .get<any>(`${this.url}/getOrgBankAccount?orgId=` + orgId)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
}
